var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInitPagePreview = void 0;

var react_1 = require("react");

var admin_core_1 = require("@wheelroom/admin-core");

var query_string_1 = __importDefault(require("query-string"));

var router_1 = require("@reach/router");

var page_preview_register_1 = require("./page-preview-register");

var page_preview_reducer_1 = require("./page-preview-reducer");

var initial_state_1 = require("./initial-state");

var action_creator_1 = require("./action-creator");

exports.useInitPagePreview = function (pageProps) {
  var location = router_1.useLocation();

  var _react_1$useContext = react_1.useContext(admin_core_1.AdminCoreContext),
      adminCoreDispatch = _react_1$useContext.adminCoreDispatch;

  var _react_1$useReducer = react_1.useReducer(page_preview_reducer_1.pagePreviewReducer, initial_state_1.initialState),
      _react_1$useReducer2 = _slicedToArray(_react_1$useReducer, 2),
      pagePreviewState = _react_1$useReducer2[0],
      pagePreviewDispatch = _react_1$useReducer2[1];

  var actions = action_creator_1.actionCreator(pagePreviewState, pagePreviewDispatch);
  react_1.useEffect(function () {
    adminCoreDispatch(page_preview_register_1.pagePreviewRegister);
  }, []);
  react_1.useEffect(function () {
    adminCoreDispatch({
      type: 'SET_PAGE_PROPS',
      pageProps: pageProps
    });
  }, [pageProps]);
  react_1.useEffect(function () {
    var queryParams = query_string_1.default.parse(location.search);
    pagePreviewState.inPreviewMode = 'preview' in queryParams;
    adminCoreDispatch({
      type: 'SET_ADMIN_MODULE_STORE',
      moduleId: page_preview_register_1.pagePreviewRegister.moduleId,
      store: {
        actions: actions,
        state: pagePreviewState,
        dispatch: pagePreviewDispatch
      }
    });
    adminCoreDispatch({
      type: 'SET_LAST_MODULE_ID',
      moduleId: page_preview_register_1.pagePreviewRegister.moduleId
    });
  }, [pagePreviewState]);
};